import { COLORS } from "components/consts";

export const TOUR_OPTIONS = {
  primaryColor: COLORS.Romance,
  disableFocusTrap: true,
  backgroundColor: "#ffffff",
  textColor: "#1a1a1a",
  overlayColor: "rgba(0, 0, 0, 0.6)",
  arrowColor: "transparent",
  width: 380,
  spotlightRadius: 8,
  spotlightPadding: 8,
  showProgress: true,
};

export const TOUR_STYLES = {
  tooltip: {
    borderRadius: 12,
    boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
    padding: "20px 24px",
  },
  tooltipTitle: {
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 8,
  },
  tooltipContent: {
    fontSize: 14,
    lineHeight: 1.6,
  },
  buttonPrimary: {
    backgroundColor: COLORS.Romance,
    borderRadius: 8,
    padding: "8px 20px",
    fontSize: 13,
    fontWeight: 600,
  },
  buttonBack: {
    color: "#666",
    fontSize: 13,
  },
  buttonSkip: {
    color: "#999",
    fontSize: 13,
  },
  beaconInner: {
    backgroundColor: COLORS.Romance,
  },
  beaconOuter: {
    backgroundColor: "#fff",
    borderColor: COLORS.Romance,
  },
  spotlight: {
    stroke: COLORS.Romance,
    strokeWidth: 2,
  }
};
